import {accountMovement} from "./es/accountMovement";
import {bankDeposit} from "./es/bankDeposit";
import {baseModalTitles} from "./es/baseModalTitles";
import {changePassword} from "./es/changePassword";
import {contact} from "./es/contact";
import {currency} from "./es/currency";
import {deleteAccount} from "./es/deleteAccount";
import {dropdownMenu} from "./es/dropdownMenu";
import {errorBoundary} from "./es/errorBoundary";
import {floatBtn} from "./es/floatBtn";
import {floatingMenu} from "./es/floatingMenu";
import {footer} from "./es/footer";
import {gameFeed} from "./es/gameFeed";
import {games} from "./es/games";
import {homeBtnMoneyHandler} from "./es/homeBtnMoneyHandler";
import {homeModalSessionInfo} from "./es/homeModalSessionInfo";
import {inviteFriend} from "./es/inviteFriend";
import {loginModal} from "./es/loginModal";
import {lottery} from "./es/lottery";
import {mobilePayment} from "./es/mobilePayment";
import {notificationDrawer} from "./es/notificationDrawer";
import {notifications} from "./es/notifications";
import {raffle} from "./es/raffle";
import {registrationForm} from "./es/registrationForm";
import {sideNavbar} from "./es/sideNavbar";
import {contactSupport} from "./es/support";
import {TOS} from "./es/TOS";
import {transactionTitles} from "./es/transactionTitles";
import {transferSteps} from "./es/transferSteps";
import {userProfile} from "./es/userProfile";
import {wallet} from "./es/wallet";
import {withdrawalSteps} from "./es/widthdrawalSteps";

const es = {
  ...contact,
  ...contactSupport,
  ...bankDeposit,
  ...currency,
  ...sideNavbar,
  ...dropdownMenu,
  ...registrationForm,
  ...userProfile,
  ...floatBtn,
  ...withdrawalSteps,
  ...homeBtnMoneyHandler,
  ...transferSteps,
  ...wallet,
  ...inviteFriend,
  ...changePassword,
  ...mobilePayment,
  ...accountMovement,
  ...transactionTitles,
  ...baseModalTitles,
  ...footer,
  ...notificationDrawer,
  ...notifications,
  ...deleteAccount,
  ...TOS,
  ...lottery,
  ...raffle,
  ...loginModal,
  ...errorBoundary,
  ...homeModalSessionInfo,
  ...games,
  ...gameFeed,
  ...floatingMenu,
  noDataAvailable: "No hay datos disponibles",
  loading: "Cargando...",
  homeDisplaySportsTitle: "APUESTAS DEPORTIVAS",
  homeDisplaySportsSubtitle: "Juega en las mejores ligas del mundo",
  homeDisplayContestChallengeTitle: "CONCURSO - Desafío del más allá",
  homeDisplayTopGamesTitle: "Los 10 Más Jugados!",
  homeDisplayAllBtn: "Ver Todos",
  homeDisplayLoginBtn: "Iniciar Sesión",
  homeDisplayRegisterBtn: "Registrarse",
  homeDisplayLiveGames: "Juegos en Vivo",
  homeDisplayFootball: "Fútbol",
  homeDisplayTennis: "Tenis",
  homeDisplayBasketball: "Baloncesto",
  homeDisplayVolleyball: "Voleibol",
  homeDisplayEventRules: "Reglas del Evento",

  homeDisplayModalTitle: "Promoción",
  homeDisplayModalClose: "Cerrar",
  homeModalSessionInfoAtTime: "Inicio de session a las ",
  referralMessage: "¡Únete a RYG y disfruta de beneficios exclusivos! Regístrate usando mi enlace de referencia ",
  referralMessageSlots: "Regístrate aquí y recibe 10 rodadas gratis en tragamonedas. ",
  referralMessageSports: "Crea tu cuenta y obtén un bono exclusivo para apostar en tu deporte favorito. ",
  referralMessageBingo: "Crea tu cuenta y recibe cartones gratis. ",
  referralMessageCasino: "Crea tu cuenta y recibe fichas gratis para el casino en vivo. ",
  selectMessageType: "Selecciona tipo de mensaje",
  messageTypeGeneral: "General",
  messageTypeSlots: "Slots",
  messageTypeSports: "Deportes",
  messageTypeBingo: "Bingo",
  messageTypeCasino: "Casino",
  messagePreview: "Vista previa del mensaje",
  copy: "Copiar",
  share: "Compartir",
  scanQR: "Escanear QR",
  scanQRText: "Escanea este código QR para referir a un amigo",
  copyQR: "Copiar QR",
  downloadQR: "Descargar QR",
  shareQR: "Compartir QR",
  qrCopied: "¡Código QR copiado al portapapeles!",
  qrCopyFailed: "Error al copiar el código QR. Por favor, intenta descargarlo.",
  recentReferrals: "Referidos Recientes",
  referralProgram: "Programa de Referidos",
  youReferralStatus: "Tu estado de referido",
  sharedYourLink:
    "Puedes compartir tu enlace de referido copiándolo y enviándolo o compartiéndolo en tus redes sociales",
  referralEarnings: "Ganancias por Referidos",
  referralSummary: "Resumen de Referidos",
  yourReferrals: "Tus Referidos",
  yourReferralsEarned: "Tus Ganancias por Referidos",
  yourReferralsPendingEarned: "Tus Ganancias Pendientes por Referidos",
  joinedDate: "Fecha de Registro",
  status: "Estado",
  reward: "Recompensa",
  depositDate: "Fecha de Depósito",
  active: "Activo",
  inactive: "Inactivo",
  noReferralsFound: "No se encontraron referidos recientes.",
  totalReferrals: "Total de Referidos",
  activeReferrals: "Referidos Activos",
  hasDeposited: "Ha Depositado",
  yes: "Sí",
  no: "No",
  date: "Fecha",
  pending: "Pendiente",
  paid: "Pagado",
  recentEarnings: "Ganancias Recientes",
  noCommissionsYet: "No hay comisiones aún",
  commission: "comisión",
  totalCommission: "Comisión Total",
  forgotReferralCode: "¿Olvidaste agregar el código de referido en tu perfil?",
  clickHere: "Haz Click Aquí",
  referralCodePlaceholder: "Ingresa tu código de referido",
  send: "Enviar",
  sending: "Enviando...",
  referralCodeAppliedSuccess: "¡Código de referencia aplicado exitosamente!",
  invalidOrInactiveReferralCode: "El código de referencia es inválido o inactivo",
};

export default es;
